import {useMemo} from 'react';
import {BasicAnalysisResult, HouseholdItem} from '@/map/@types';
import {MAX_VISIBLE_ZOOM_METER} from '@/map/constants';
import {AreaAnalyticsFilter} from '@/map/enums';
import {useVisibleZoomLevel} from '@/map/hooks';
import {HouseMarker} from '../../Markers/House/HouseMarker';

interface IProps {
  map?: naver.maps.Map;
  items?: BasicAnalysisResult;
}

export const HouseMarkers = ({map, items}: IProps) => {
  const isVisibleZoom = useVisibleZoomLevel(
    MAX_VISIBLE_ZOOM_METER.mobile_markers
  );

  const markers = useMemo<HouseholdItem[] | undefined>(() => {
    if (items) {
      const ret: any = items[AreaAnalyticsFilter.HOUSE]
        ? [...items[AreaAnalyticsFilter.HOUSE]]
        : [];

      if (items[AreaAnalyticsFilter.UPCOMMING_APTS]) {
        ret.push({
          type: AreaAnalyticsFilter.UPCOMMING_APTS,
          locationInfo: items[AreaAnalyticsFilter.UPCOMMING_APTS],
        });
      }

      return ret;
    }
  }, [items]);

  if (!map || !items || !markers?.length || !isVisibleZoom) {
    return null;
  }

  return (
    <>
      {markers.map((building) =>
        building.locationInfo.map(
          (i, idx) =>
            idx < 50 && (
              <HouseMarker
                key={idx}
                type={building.type}
                item={i}
                map={map}
                isSimple
              />
            )
        )
      )}
    </>
  );
};
